import Reuqest from "./request/index";

export const service = new Reuqest({
	// baseURL: process.env.NODE_ENV !== "development" ? "https://api.argos-jpc.com" : "https://api.staging-argos-jpc.com",
	// baseURL: "https://api.staging-argos-jpc.com",
	baseURL: process.env.VUE_APP_BASE_URL,
	timeout: 50000,
});